import script from "./workloadsTableCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./workloadsTableCell.vue?vue&type=script&setup=true&lang=ts"

import "./workloadsTableCell.vue?vue&type=style&index=0&id=cd6186c4&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd6186c4"]])

export default __exports__